module.exports = __webpack_public_path__ + "media/svg-new/avatar-2 7-fe9d00c4.svg";